module.exports = __webpack_public_path__ + "img/inserts.8a4ca429.png";